import React from 'react';
import { useMachineBranchInputQuery } from '../../../../../../../services';
import { RhSingleAutocomplete } from '../../../../../../dum';
import { IMachine } from '../s-machine-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

export function BranchInput() {
    const { data } = useMachineBranchInputQuery();
    const INPUT_NAME: keyof IMachine = 'branch_id';

    return (
        <RhSingleAutocomplete
            itemText={'name'}
            itemValue={'id'}
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.branch_id)}
            options={data?.getBranches || []}
        />
    );
}
